import CategorySlider from '../components/CategorySlider';
import FeaturedProducts from '../components/FeaturedProducts';
import NewProducts from '../components/NewProducts';
import AllCollections from '../components/AllCollections';
import SEO from '../components/SEO';
import Sliders from '../components/Sliders';  
import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Home() {
  // Usar el hook de autenticación
  const { user } = useAuth();
  

  
  return (
    <>
      <SEO 
        title="Tienda" 
        description="Disolgua - Distribuidora del Sol Guatemala S.A. Somos tu socio mayorista de confianza. Ofrecemos peluches, tarjetas, globos y artículos para regalo a precios competitivos."
        keywords={['mayorista', 'Guatemala', 'peluches', 'tarjetas', 'globos', 'regalos', 'distribuidora', 'precios mayoristas']}
        url="/"
        type="website"
      />
      

     
 
      <div className="w-full py-10 bg-yellow-400">
        <div className="max-w-7xl mx-auto px-4 space-y-8">
          <Sliders />
        </div>
       
        {!user && (
          <div className='max-w-7xl mx-auto px-4 flex flex-col items-center gap-4 mt-10'>
            <Link
              to='/register?type=mayorista'
              className='mt-1 inline-block px-10 py-4 bg-blue-600 text-white font-bold rounded-full shadow-lg hover:bg-blue-500 transition-colors text-2xl md:text-3xl tracking-wide w-full md:w-auto text-center border-4 border-white'
            >
              ¿Eres Mayorista? Regístrate aquí
            </Link>
          </div>
        )}
      
      </div>
      
      
    
      <CategorySlider />
      <div className="max-w-7xl mx-auto px-4 py-4 space-y-8">
        <div id="featured">
          <FeaturedProducts />
        </div>
        <div id="collections">
          <AllCollections />
        </div>
        <div id="new">
          <NewProducts />
        </div>
      </div>
    </> 
  );
}